import { render, staticRenderFns } from "./dealerTagList.vue?vue&type=template&id=1ef8c3db&scoped=true"
import script from "./dealerTagList.vue?vue&type=script&lang=js"
export * from "./dealerTagList.vue?vue&type=script&lang=js"
import style0 from "./dealerTagList.vue?vue&type=style&index=0&id=1ef8c3db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef8c3db",
  null
  
)

export default component.exports